import { createContext } from 'react';
import {
	DevicesNotificationFileTypes,
	IDeviceNotificationsData,
	IItemDeviceForGetInfo,
	TDropboxPushMessage,
} from 'types';

export type TTypeOfModalWindow = null | 'success' | 'error' | 'confirm' | 'dropBoxPush';
export interface IDataForPushArgs {
	hardwareId: string;
	data: IDeviceNotificationsData;
}

export interface IDeviceFullInfoState {
	deviceForFullInfo: Nullable<IItemDeviceForGetInfo>;
	selectedDropboxPushFileType: Nullable<DevicesNotificationFileTypes>;
	selectedDropboxPushMessage: Nullable<TDropboxPushMessage>;
	dropboxPushParams: string;
	dataForPush: Nullable<IDataForPushArgs>;
	isBackupEnabled: boolean;
	isDeactivateDeviceWithRemoveContent: boolean;
	isDeactivateDeviceWithResetRestaurant: boolean;
	typeOfModalWindow: TTypeOfModalWindow;
}

export const deviceFullInfoInitialState: IDeviceFullInfoState = {
	deviceForFullInfo: null,
	selectedDropboxPushFileType: null,
	selectedDropboxPushMessage: null,
	dropboxPushParams: '',
	dataForPush: null,
	isBackupEnabled: true,
	isDeactivateDeviceWithRemoveContent: false,
	isDeactivateDeviceWithResetRestaurant: false,
	typeOfModalWindow: null,
};

export interface IDeviceFullInfoContext extends IDeviceFullInfoState {
	setDeviceForFullInfo(value: Nullable<IItemDeviceForGetInfo>): void;
	setDropboxPushFileType(value: Nullable<DevicesNotificationFileTypes>): void;
	setDropboxPushMessage(value: Nullable<TDropboxPushMessage>): void;
	changeDropboxPushParams(value: string): void;
	resetDropboxPushFields(): void;
	resetModalState(): void;
	setDataForPush(dataForPush: IDataForPushArgs | null): void;
	switchBackupEnabled(value: boolean): void;
	setDeactivateDeviceWithRemoveContent(): void;
	setDeactivateDeviceWithResetRestaurant(): void;
	changeTypeOfModalWindow(value: TTypeOfModalWindow): void;
}

export const DeviceFullInfoContext = createContext<IDeviceFullInfoContext>({
	setDeviceForFullInfo: () => undefined,
	setDropboxPushFileType: () => undefined,
	setDropboxPushMessage: () => undefined,
	changeDropboxPushParams: () => undefined,
	resetDropboxPushFields: () => undefined,
	resetModalState: () => undefined,
	setDataForPush: () => undefined,
	switchBackupEnabled: () => undefined,
	setDeactivateDeviceWithRemoveContent: () => undefined,
	setDeactivateDeviceWithResetRestaurant: () => undefined,
	changeTypeOfModalWindow: () => undefined,
	...deviceFullInfoInitialState,
});
